//imports
import UnderlineHeading from "../../../../components/underlineHeading";
import CommonTable from "../../../../components/commonTable";
import Card from "../../../../components/card";
import FiltersController from "./filters/filtersController";
import AttendancesModalController from "./modal/attendancesModalController";
import { AttendancesViewProps } from "./interfaces";
import MiniModalController from "../../../../components/modals/miniModal/miniModalController";
import PaginationComponent from "../../../../components/pagination/pagination";
import ReportButtonComponent from "../../../../components/buttons/reportButton/reportButton";
import Constants, { REPORT_TYPES } from "../../../../constants";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { solid } from "@fortawesome/fontawesome-svg-core/import.macro";
import ReactDatePicker from "react-datepicker";
import SearchInputComponent from "../../../../components/searchInput/searchInput";
import TarjetasHorarios from "./tarjetas/tarjetasHorarios";
import { useEsTelefono } from "../../../../utils/esTelefono";
import { ROLE } from "../../../../constants";
import FiltrosRapidos from "../../../../components/filtrosRapidos/filtrosRapidos";
import TableroDelDia from "./tableroDelDia/tableroDelDia";
import TalleresMaestra from "../workshops/talleresMaestra";

//styles
import "./styles.scss";
import { ahoraCdmx } from "../../../../utils/horaMexico";

const DIAS = ["domingo", "lunes", "martes", "miércoles", "jueves", "viernes", "sábado"]

/*
	Los tres chips con los que abre Asistencias. Se definen aqui, y no dentro del
	componente, porque ese ahora lo comparten varios modulos y cada uno trae los
	suyos. (Esteban, 2026-09-16)
*/
const CHIPS_ASISTENCIAS =
[
	{llave : "hoy", texto : "Hoy", ayuda : "Solo los horarios que tienen clase el " + DIAS[ahoraCdmx().getDay()]},
	{llave : "vigentes", texto : "En vigencia", ayuda : "Solo los que ya empezaron y todavía no terminan"},
	{llave : "conAlumnos", texto : "Con alumnos", ayuda : "Esconde los horarios sin nadie matriculado"}
]

const AttendancesView = ({
	rapidos,
	onRapidos,
	panelFiltros,
	onPanelFiltros,
	sectionLoaded,
	schedules,
	setSchedules,
	selectedSchedule,
	setSelectedSchedule,
	displayError,
	columns,
	filters,
	onFilterChange,
	onClearFilters,
	itemsPerPage,
	handlePageSizeChange,
	pages,
	pagesSize,
	itemCount,
	showInfoModal,
	dataInfoModal,
	closeInfoModal,
	miniMessage,
	scheduleClick,
	idleLocked,
	userProfile,
	reportProps,
	searchProps,
	tableroProps
}: AttendancesViewProps) => {

	/*
		En telefono la tabla de ocho columnas se vuelve una rejilla que hay que
		arrastrar de lado. Debajo de 768px se cambia por tarjetas; la vista de
		computadora no se toca, que es donde trabajan Servicios Académicos y Caja.
	*/
	const esTelefono = useEsTelefono();
	const esMentor = userProfile.currentRole === ROLE.MENTOR;

	return (
		<>
			{
				!sectionLoaded ? ""
					:
					<div className="attendancesContainer">
						<h2 className="pageHeader">
							Asistencias
						</h2>
						<UnderlineHeading />
						{
							esMentor ? null :
								<div className="downloadMentorsSalaryReportContainer">
									<button
										className="downloadMentorsSalaryReport btn btn-success"
										onClick={reportProps.openModal}
										disabled={idleLocked}
										type="button">
										<FontAwesomeIcon icon={solid("file-excel")} />
										<span className="ps-2 d-none d-lg-inline">
											{reportProps.title}
										</span>
									</button>
								</div>
						}
						{
							/*
								Quien ya paso lista hoy y quien no, por jornada. Va arriba de los
								filtros porque es lo primero que se viene a ver por la manana; al
								profesor no se le ensena, que solo ve sus propios horarios.
								(Esteban, 2026-09-20)
							*/
							esMentor ? null : <TableroDelDia
								dia={tableroProps.dia}
								plantel={tableroProps.plantel}
								cargando={tableroProps.cargando}
								onPasarLista={tableroProps.onPasarLista}
								onRecargar={tableroProps.onRecargar}
								onCambiarDia={tableroProps.onCambiarDia}
								enHoy={tableroProps.enHoy}
							/>
						}
						{
							/* La maestra pasa lista de sus talleres aquí, como en sus horarios (Módulos Claros, 2026-11-01). */
							esMentor ? <TalleresMaestra /> : null
						}
						<FiltrosRapidos
							chips={CHIPS_ASISTENCIAS}
							porOmision={{hoy : true, vigentes : true, conAlumnos : true}}
							nombreUno="horario"
							nombreVarios="horarios"
							marcador="Buscar curso, código o profesor"
							valores={rapidos}
							onCambio={onRapidos}
							busqueda={searchProps.search}
							onBusqueda={searchProps.onChangeSearch}
							onBuscar={searchProps.onClickSearch}
							onLimpiar={searchProps.onClearSearch}
							idleLocked={idleLocked}
							cuenta={itemCount?.total}
							panelAbierto={panelFiltros}
							onPanel={onPanelFiltros}
							panel={
								esMentor ? null :
									<FiltersController
										displayError={displayError}
										setSchedules={setSchedules}
										itemsPerPage={itemsPerPage}
									/>
							}
						/>
						{
							esTelefono
								?
								<TarjetasHorarios
									schedules={schedules}
									esMentor={esMentor}
									onSchedule={scheduleClick}
									idleLocked={idleLocked}
								/>
								:
								<Card>
									<div className="containerTable col-lg-12">
										<CommonTable
											columns={columns}
											data={schedules}
											onRowClick={scheduleClick}
											filters={filters}
											onFilterChange={onFilterChange}
											onClearFilters={onClearFilters}
										>
										</CommonTable>
									</div>
								</Card>
						}
						<br />
						{
							selectedSchedule ?
								<AttendancesModalController
									selectedSchedule={selectedSchedule}
									setSelectedSchedule={setSelectedSchedule}
									miniMessage={miniMessage}
								/>
								:
								""
						}
						<MiniModalController
							title={dataInfoModal.title ? dataInfoModal.title : ""}
							show={showInfoModal}
							onClose={closeInfoModal}
						>
							{
								dataInfoModal.content
							}
						</MiniModalController>
						<div className="attendancesPagination">
							<PaginationComponent
								pages={pages}
								onPageSizeChange={handlePageSizeChange}
								pageSizeVisible={true}
								pageSizes={pagesSize}
								itemCount={itemCount}
								style={{ paddingBottom: 0 }}
							/>
						</div>
						<MiniModalController
							title={reportProps.title}
							show={reportProps.showModal}
							onClose={reportProps.closeModal}
						>
							{
								<div className="d-flex flex-column align-items-center">
									<div className="d-flex my-3 datePickerContainer">
										<ReactDatePicker
											selectsRange
											startDate={reportProps.startDate}
											endDate={reportProps.endDate}
											selected={reportProps.startDate}
											onChange={reportProps.onChange}
											isClearable={true}
											showIcon
											className="gary-border"
										/>
									</div>
									<ReportButtonComponent
										onClick={() => reportProps.confirmDownloadReport(reportProps.handleDownloadReport)}
										reportType={REPORT_TYPES.XLSX}
										disabled={(!reportProps.startDate ? true : false) || (!reportProps.endDate ? true : false)}
									/>
								</div>
							}
						</MiniModalController>
					</div>
			}
		</>
	);
}

export default AttendancesView